const ModalHeaderDirective = function () {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        template: '<div class="header"><h4 class="light green-text truncate"><ng-transclude></ng-transclude></h4></div>'
    }
};

export { ModalHeaderDirective };